import React from "react";
import { Button } from "../ui/button";

export function HeaderActions({
  showCheckRates = true,
  showApplyLoan = true,
  onCheckRatesClick,
  onApplyLoanClick,
  disableApplyLoan = false
}) {
  return (
    <div className="flex items-center gap-3">
      {showCheckRates && (
        <Button
          variant="outline"
          size="default"
          className="border-[#343c76] text-[#343c76] bg-transparent hover:shadow-md"
          onClick={onCheckRatesClick}
        >
          Check Rates
        </Button>
      )}
      {showApplyLoan && (
        <Button
          variant="default"
          size="default"
          className="bg-[#343c76] text-white hover:shadow-md"
          onClick={onApplyLoanClick}
          disabled={disableApplyLoan}
        >
          Apply for Loan
        </Button>
      )}
    </div>
  );
}
